/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Fresh_Swift_Otter_PeekInputs */

const en_fresh_swift_otter_peek = /** @type {(inputs: Fresh_Swift_Otter_PeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Completed with errors (${i?.count})`)
};

const de_fresh_swift_otter_peek = /** @type {(inputs: Fresh_Swift_Otter_PeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abgeschlossen mit Fehlern (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Completed with errors ({count})" |
*
* @param {Fresh_Swift_Otter_PeekInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fresh_swift_otter_peek = /** @type {((inputs: Fresh_Swift_Otter_PeekInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fresh_Swift_Otter_PeekInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fresh_swift_otter_peek(inputs)
	return de_fresh_swift_otter_peek(inputs)
});